import React from 'react';
import { Button } from '@ygtechnologies/rubus-ui';
import { Trans, useLingui } from '@lingui/react/macro';
import { ConfiguratorPresetDto } from '@/services/configurator';
import { useConfiguratorMutations } from '../ConfiguratorMutationContext';

export interface SelectStyleButtonProps {
    roomId: string | undefined;
    style: ConfiguratorPresetDto;
    disabled?: boolean;
}

export const SelectStyleButton: React.FC<SelectStyleButtonProps> = ({ style, roomId, disabled }) => {
    const { t } = useLingui();
    const { pickStyle, isPickingStyle } = useConfiguratorMutations();
    return (
        <Button
            variant="tertiary"
            size="lg"
            disabled={disabled}
            title={disabled ? t`Deadline has expired` : undefined}
            onClick={() => pickStyle(style.id, roomId ? Number(roomId) : undefined)}
            loading={isPickingStyle}
        >
            <Trans>Select style</Trans>
        </Button>
    );
};
